<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <div class="row align-items-center py-4 mx-0">
              <div class="col-auto">
                <span style="font-size: 25px; color: black;">กลุ่มวัตถุดิบ, แบรนด์, ประเภท</span>
              </div>
              <div class="col-12 col-sm-auto my-1 my-sm-0">
                <template v-if="checkmodal === 'add'">
                  <b-modal v-model="showModal" :title='headerModal + " (เพิ่ม)"' cancel-title="เพิ่ม" ok-title="ยกเลิก"
                    cancel-variant="primary" ok-variant="danger" @cancel="addSupplier" @ok="handleClick()"
                    :cancel-disabled="!supplier.var_supplier1 ? true : false" @close.prevent="checkmodal === 'view' ? showModal=false : handleClick()"
                    :no-close-on-esc="true" :no-close-on-backdrop="true">
                    <b-form-group :label='"ชื่อ" + headerModal' style="color: black;">
                      <template v-if="supplier.var_supplier1 === '' || supplier.var_supplier1 === null || !supplier.var_supplier1?.trim()" v-slot:label>
                        ชื่อ{{ headerModal }}<span class="text-danger"> *</span>
                      </template>
                      <b-form-input id="" v-model="supplier.var_supplier1" type="text"></b-form-input>
                    </b-form-group>
                    <template #modal-footer>
                        <div class="w-100" style="display: flex; justify-content: flex-end; gap: 0.5rem;">
                          <b-button
                            style="border-radius: 0.5rem; padding: 0 .7rem;"
                            variant="primary"
                            class="btn-min-size"
                            size="sm"
                            @click="addSupplier"
                            :disabled="supplier.var_supplier1?.trim() ? false : true"
                            :hidden="checkmodal === 'view' ? true : false"
                          >
                            <i class="save-data_ct"/>บันทึก
                          </b-button>
                          <b-button
                            variant="none"
                            class="iq-bg-danger btn-cancel-border btn-min-size"
                            style="border-radius: 0.5rem;"
                            size="sm"
                            @click="handleClick()"
                          >
                            ยกเลิก
                          </b-button>
                        </div>
                      </template>
                  </b-modal>
                </template>
                <template v-else>
                  <b-modal v-model="showModal" :title="`${checkmodal === 'view' ? headerModal + ' (ดูรายละเอียด)' : headerModal + ' (แก้ไข)'}`" cancel-title="แก้ไข" ok-title="ยกเลิก"
                    cancel-variant="primary" ok-variant="danger" @cancel="editSupplier" @ok="checkmodal === 'view' ? showModal=false : handleClick()"
                    :cancel-disabled="!supplier.var_supplier1 ? true : false" @close.prevent="checkmodal === 'view' ? showModal=false : handleClick()"
                    :no-close-on-esc="true" :no-close-on-backdrop="true">
                    <b-form-group :label='"ชื่อ" + headerModal' style="color: black;">
                      <template v-if="supplier.var_supplier1 === '' || supplier.var_supplier1 === null || !supplier.var_supplier1?.trim()" v-slot:label>
                        ชื่อ{{ headerModal }}<span class="text-danger"> *</span>
                      </template>
                      <b-form-input :disabled="checkmodal === 'view' ? true : false" id="" v-model="supplier.var_supplier1" type="text"></b-form-input>
                    </b-form-group>
                    <template #modal-footer>
                        <div class="w-100" style="display: flex; justify-content: flex-end; gap: 0.5rem;">
                          <b-button
                            style="border-radius: 0.5rem; padding: 0 .7rem;"
                            variant="primary"
                            class="btn-min-size"
                            size="sm"
                            @click="editSupplier(supplier.id)"
                            :disabled="supplier.var_supplier1?.trim() ? false : true"
                            :hidden="checkmodal === 'view' ? true : false"
                          >
                            <i class="save-data_ct"/>บันทึก
                          </b-button>
                          <b-button
                            variant="none"
                            class="iq-bg-danger btn-cancel-border btn-min-size"
                            style="border-radius: 0.5rem;"
                            size="sm"
                            @click="checkmodal === 'view' ? showModal=false : handleClick()"
                          >
                            ยกเลิก
                          </b-button>
                        </div>
                      </template>
                  </b-modal>
                </template>
              </div>
            </div>
          </template>
          <template v-slot:body>
            <!-- Tabs -->
            <b-row class="mb-3 ml-1 mr-1"
                style="flex-wrap: nowrap; overflow: overlay; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <b-text class="mr-4 px-3 pb-2 unselectable" style="white-space: nowrap; cursor: pointer;"
                  :style="{ color: activeTab === 'tab1' ? 'rgb(8, 159, 175)' : 'black', borderBottom: activeTab === 'tab1' ? 'rgb(8, 159, 175) solid 2px' : '' }"
                  @click="onChangeTab('tab1')">กลุ่มวัตถุดิบ </b-text>
                <b-text class="mr-4 px-3 pb-2 unselectable" style="white-space: nowrap; cursor: pointer;"
                  :style="{ color: activeTab === 'tab2' ? 'rgb(8, 159, 175)' : 'black', borderBottom: activeTab === 'tab2' ? 'rgb(8, 159, 175) solid 2px' : '' }"
                  @click="onChangeTab('tab2')">แบรนด์</b-text>
                <b-text class="mr-4 px-3 pb-2 unselectable" style="white-space: nowrap; cursor: pointer;"
                  :style="{ color: activeTab === 'tab3' ? 'rgb(8, 159, 175)' : 'black', borderBottom: activeTab === 'tab3' ? 'rgb(8, 159, 175) solid 2px' : '' }"
                  @click="onChangeTab('tab3')">ประเภท</b-text>
            </b-row>
            <div class="mx-3">
              <b-row style="justify-content: space-between;">
                <b-col cols="12" md="7" lg="5" class="mb-3">
                  <b-row>
                    <b-col sm="12" md class="mb-3">
                      <div class="iq-email-search d-flex">
                        <div style="width: 100%;">
                          <div class="form-group mb-0">
                            <input class="form-control" id="exampleInputEmail1" placeholder="Search" style="width: 100%;" v-model="searchTerm" @keydown="enterSearch">
                            <a class="search-link" v-on:click="getMaterialGroup"><i class="ri-search-line" /></a>
                          </div>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="auto" class="mb-3" style="display: flex; align-items: center;">
                      <span class="mx-2 font-size-14 text-primary unselectable">
                        {{ materialgroup.data?.length > 0 ? (((currentPage - 1) * 10) + 1) + ' - ' + (((perPage * currentPage) > materialgroup.data?.length) ? materialgroup.data?.length : (perPage * currentPage) ) + ' of ' + materialgroupLength : '0 of ' + materialgroupLength }} รายการ
                        <!-- {{ materialgroup.data?.length > 0 ? "1 -" + materialgroup.data?.length + " of " + materialgroup.data?.length : "0 - 0 of 0" }} -->
                      </span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="1.5" class="mb-3 mr-3 ml-3">
                    <b-button type="submit" variant="primary" @click="resetValue(), showModal = true, checkmodal = 'add'" class="w-100 btn-min-size"><i class="circle-plus_ct"></i>เพิ่ม</b-button>
                </b-col>
              </b-row>
            </div>
            <b-col md="12" class="table-responsive">
              <b-table bordered hover :items="materialgroup.data" :fields="columns"
                :current-page="currentPage"
                :per-page="perPage"
                @pagination="onPagination"
                :tbody-tr-class="rowClass" thead-class="table-header-color"
                >
                <template v-slot:cell(variable1)="data">
                  <span v-if="!data.item.editable">{{ ((currentPage - 1) * 10) + data.index + 1 }}</span>
                </template>
                <template v-slot:cell(variable2)="data">
                  <span v-if="!data.item.editable">{{ materialgroup.data[((currentPage - 1) * 10) + data.index].name }}</span>
                </template>
                <template v-slot:cell(variable3)="data">
                  <div style="display: flex; justify-content: center;">
                    <b-button title="ดูรายละเอียด" variant=" iq-bg-info mr-1" size="sm" @click="showModal = true, checkmodal = 'view', setEditSupplier(data.item, ((currentPage - 1) * 10) + data.index)"><i class="ri-eye-fill m-0"></i></b-button>
                    <a v-if="((currentPage - 1) * 10) + data.index + 6 <= 5 " :disabled="((currentPage - 1) * 10) + data.index + 6 <= 5 ? true : false" size="sm" @click="showModal = true, checkmodal = 'edit', setEditSupplier(data.item, ((currentPage - 1) * 10) + data.index)" class="p-3" style="color: white !important;"><i :hidden="((currentPage - 1) * 10) + data.index + 6 <= 5 ? true : false" class="ri-delete-bin-line m-0"></i></a>
                    <b-button v-else title="แก้ไข" variant=" iq-bg-success mr-1" size="sm" @click="showModal = true, checkmodal = 'edit', setEditSupplier(data.item, ((currentPage - 1) * 10) + data.index)" ><i class="ri-ball-pen-fill m-0"></i></b-button>
                    <a v-if="((currentPage - 1) * 10) + data.index + 6 <= 5 " :disabled="((currentPage - 1) * 10) + data.index + 6 <= 5 ? true : false" size="sm" @click="this.remove(materialgroup.data[((currentPage - 1) * 10) + data.index].id)" class="p-3" style="color: white !important;"><i :hidden="((currentPage - 1) * 10) + data.index + 6 <= 5 ? true : false" class="ri-delete-bin-line m-0"></i></a>
                    <b-button v-else title="ลบ" variant=" iq-bg-danger" :hidden="((currentPage - 1) * 10) + data.index + 6 <= 5 ? true : false" :disabled="((currentPage - 1) * 10) + data.index + 6 <= 5 ? true : false" size="sm" @click="remove(materialgroup.data[((currentPage - 1) * 10) + data.index].id)"><i class="ri-delete-bin-line m-0"></i></b-button>
                  </div>
                </template>
              </b-table>
              <br>
              <b-pagination v-model="currentPage" :total-rows="materialgroup.data?.length" :per-page="perPage" align="center" />
            </b-col>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<style>
.width-label{
  width: 200px !important;
}
</style>

<script>
import { xray } from '../../config/pluginInit'
// import router from '@/router'
import axios from 'axios'
import Vue from 'vue'
import { configAPI } from '../../configBase'

export default {
  name: 'UiDataTable',
  async mounted () {
    xray.index()
    await this.getMaterialGroup()
  },
  methods: {
    async enterSearch (e) {
      if (e.key === 'Enter') {
        await this.getMaterialGroup()
      }
    },
    async getMaterialGroup () {
      let search = this.searchTerm.trim().length > 0 ? this.searchTerm.trim() : ''
      let materialGroupAPI = {
        method: 'get',
        url: `${configAPI.MD_PORT}/api/materialGroup?search=` + search,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      if (this.activeTab === 'tab2') {
        materialGroupAPI = {
          method: 'get',
          url: `${configAPI.MD_PORT}/api/materialBrand?search=` + search,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      } else if (this.activeTab === 'tab3') {
        materialGroupAPI = {
          method: 'get',
          url: `${configAPI.MD_PORT}/api/materialType?search=` + search,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      }
      await axios.request(materialGroupAPI)
        .then((response) => {
          this.materialgroup = response.data
          this.materialgroupLength = response.data.count
        })
    },
    SwalError (error, message) {
      Vue.swal.fire({
        title: `<span class="" style="font-size: 25px; color: black; text-align: center">${message}</span>`,
        html: '<span>' + error + '</span>',
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
        confirmButtonColor: '#089bab',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1'
        }
      })
    },
    convertToJson () {
      let dataList = {}
      dataList = {
        clinic_id: 'e4b50224-0068-11ee-be56-0242ac120002',
        name: this.supplier.var_supplier1?.trim(),
        is_use: true
      }
      return dataList
    },
    add () {
      let obj = this.default()
      this.rows.push(obj)
    },
    default () {
      return {
        id: this.rows.length,
        variable1: '',
        variable2: '',
        variable3: '',
        variable4: '',
        variable5: '2011/04/25',
        variable6: '$0',
        editable: false
      }
    },
    resetValue () {
      this.supplier.var_supplier1 = null
      this.supplier.var_supplier2 = null
    },
    edit (item) {
      item.editable = true
    },
    submit (item) {
      item.editable = false
    },
    remove (id) {
      Vue.swal({
        title: '<span class="" style="font-size: 25px; color: black; text-align: center">คุณมั่นใจว่าจะลบข้อมูลใช่หรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        confirmButtonColor: '#089bab',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          let DelmaterialGroupAPI = {
            method: 'post',
            url: `${configAPI.MD_PORT}/api/${this.modulePath}/${id}/delete`,
            headers: {
              'Content-Type': 'application/json'
            }
          }
          axios.request(DelmaterialGroupAPI).then(() => {
            Vue.swal({
              title: '<span class="" style="font-size: 25px; color: black; text-align: center">ลบข้อมูลสำเร็จ</span>',
              text: '',
              icon: 'success',
              allowEscapeKey: false,
              allowOutsideClick: false,
              showConfirmButton: false,
              timer: 2000,
              // confirmButtonText: '<b-button style="font-size: 14px; text-align: center">OK</b-button>', // Adjust the confirm button font size
              customClass: {
                confirmButton: 'custom-confirm-button-class'
              },
              confirmButtonColor: '#099FB0'
            }).then(() => {
              this.showModal = false
              this.getMaterialGroup()
            })
          }).catch(() => {
            Vue.swal({
              title: '<span class="" style="font-size: 25px; color: black; text-align: center">ลบข้อมูลไม่สำเร็จ</span>',
              text: '',
              icon: 'error',
              allowEscapeKey: false,
              allowOutsideClick: false,
              showConfirmButton: false,
              timer: 2000,
              // confirmButtonText: '<b-button style="font-size: 14px; text-align: center">OK</b-button>', // Adjust the confirm button font size
              customClass: {
                confirmButton: 'custom-confirm-button-class'
              },
              confirmButtonColor: '#099FB0'
            }).then(() => {
              this.showModal = false
              this.getMaterialGroup()
            })
          })
        }
      })
      // let index = this.rows.indexOf(item)
      // this.rows.splice(index, 1)
    },
    onPagination (page) {
      this.currentPage = page
    },
    handleClick () {
      Vue.swal({
        title: '<span class="" style="font-size: 25px; color: black; text-align: center">คุณมั่นใจว่าจะยกเลิกใช่หรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        confirmButtonColor: '#089bab',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.showModal = false
        }
      })
    },
    addSupplier () {
      Vue.swal({
        title: '<span class="" style="font-size: 25px; color: black; text-align: center">คุณมั่นใจว่าจะบันทึกข้อมูลใช่หรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        confirmButtonColor: '#089bab',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          let AddmaterialGroupAPI = {
            method: 'post',
            url: `${configAPI.MD_PORT}/api/${this.modulePath}`,
            headers: {
              'Content-Type': 'application/json'
            },
            data: this.convertToJson()
          }
          await axios.request(AddmaterialGroupAPI).then((response) => {
            if (response.data.status) {
              this.showModal = false
              this.getMaterialGroup()
              Vue.swal({
                title: '<span class="" style="font-size: 25px; color: black; text-align: center">บันทึกข้อมูลสำเร็จ</span>',
                text: '',
                icon: 'success',
                timer: 2000,
                allowEscapeKey: false,
                allowOutsideClick: false,
                // confirmButtonText: '<b-button style="font-size: 14px; text-align: center">OK</b-button>', // Adjust the confirm button font size
                customClass: {
                  confirmButton: 'custom-confirm-button-class'
                },
                confirmButtonColor: '#099FB0'
              })
            } else {
              this.SwalError(response.data.error === 'name duplicate' ? this.headerModal + 'นี้ซ้ำกับในระบบ กรุณาลองใหม่' : response.data.error, 'บันทึกข้อมูลไม่สำเร็จ')
            }
          }).catch((error) => {
            /* this.showModal = false
            this.getMaterialGroup() */
            this.SwalError(error.message, 'บันทึกข้อมูลไม่สำเร็จ')
          })
        }
      })
    },
    setEditSupplier (data, index) {
      this.supplier.id = data.id
      this.supplier.index = data.index
      this.supplier.var_supplier1 = data.name?.trim()
    },
    resetSupplier () {
      this.supplier.id = null
      this.supplier.index = null
      this.supplier.var_supplier1 = null
      this.showModal = true
      // this.indexTableEdit = index
    },
    editSupplier (id) {
      Vue.swal({
        title: '<span class="" style="font-size: 25px; color: black; text-align: center">คุณมั่นใจว่าจะแก้ไขข้อมูลใช่หรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        confirmButtonColor: '#089bab',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          let EditmaterialGroupAPI = {
            method: 'put',
            url: `${configAPI.MD_PORT}/api/${this.modulePath}/` + id,
            headers: {
              'Content-Type': 'application/json'
            },
            data: this.convertToJson()
          }
          await axios.request(EditmaterialGroupAPI).then(async (response) => {
            if (response.data.status) {
              this.showModal = false
              this.getMaterialGroup()
              Vue.swal({
                title: '<span class="" style="font-size: 25px; color: black; text-align: center">แก้ไขข้อมูลสำเร็จ</span>',
                text: '',
                icon: 'success',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                timer: 2000,
                // confirmButtonText: '<b-button style="font-size: 14px; text-align: center">OK</b-button>', // Adjust the confirm button font size
                customClass: {
                  confirmButton: 'custom-confirm-button-class'
                },
                confirmButtonColor: '#099FB0'
              })
            } else {
              this.SwalError(response.data.error === 'name duplicate' ? this.headerModal + 'นี้ซ้ำกับในระบบ กรุณาลองใหม่' : response.data.error, 'แก้ไขข้อมูลไม่สำเร็จ')
            }
          }).catch((error) => {
            /* this.showModal = false
            this.getMaterialGroup() */
            this.SwalError(error.message, 'แก้ไขข้อมูลไม่สำเร็จ')
          })
        }
      })
      // this.rows[this.indexTableEdit].id = this.rows[this.indexTableEdit].id || ''
      // this.rows[this.indexTableEdit].variable1 = this.rows[this.indexTableEdit].variable1 || ''
      // this.rows[this.indexTableEdit].variable2 = this.supplier.var_supplier1
      // this.rows[this.indexTableEdit].variable3 = this.supplier.var_supplier2
      // this.rows[this.indexTableEdit].variable4 = this.supplier.var_supplier3
      // this.rows[this.indexTableEdit].variable5 = this.supplier.var_supplier4
      // this.showModal = false
      // console.log('editSupplier', this.rows)
    },
    rowClass (item, type) {
      if (!item || type !== 'row') return ''
      const index = this.materialgroup.data.indexOf(item) + 1
      if (index % 2 === 1) return 'table-body-color'
    },
    onChangeTab (tab) {
      if (tab === 'tab1') {
        this.modulePath = 'materialGroup'
        this.headerModal = 'กลุ่มวัตถุดิบ'
        this.columns = [
          { label: 'ลำดับ', key: 'variable1', class: 'text-center table-size-100-300' },
          { label: 'กลุ่มวัตถุดิบ', key: 'variable2', class: 'text-center table-size-200-400' },
          { label: 'จัดการ', key: 'variable3', class: 'text-center table-size-200-400' }
        ]
      } else if (tab === 'tab2') {
        this.modulePath = 'materialBrand'
        this.headerModal = 'แบรนด์'
        this.columns = [
          { label: 'ลำดับ', key: 'variable1', class: 'text-center table-size-100-300' }, /* รหัสวัตถุดิบ */
          { label: 'แบรนด์', key: 'variable2', class: 'text-center table-size-200-400' },
          { label: 'จัดการ', key: 'variable3', class: 'text-center table-size-200-400' }
        ]
      } else if (tab === 'tab3') {
        this.modulePath = 'materialType'
        this.headerModal = 'ประเภท'
        this.columns = [
          { label: 'ลำดับ', key: 'variable1', class: 'text-center table-size-100-300' }, /* รหัสวัตถุดิบ */
          { label: 'ประเภท', key: 'variable2', class: 'text-center table-size-200-400' },
          { label: 'จัดการ', key: 'variable3', class: 'text-center table-size-200-400' }
        ]
      }
      this.activeTab = tab
      this.searchTerm = ''
      this.currentPage = 1
      this.getMaterialGroup()
    }
  },
  data () {
    return {
      activeTab: 'tab1',
      searchTerm: '',
      materialgroup: [],
      materialgroupLength: 0,
      showModal: false,
      columns: [
        { label: 'ลำดับ', key: 'variable1', class: 'text-center table-size-100-300' }, /* รหัสวัตถุดิบ */
        { label: 'กลุ่มวัตถุดิบ', key: 'variable2', class: 'text-center table-size-200-400' },
        { label: 'จัดการ', key: 'variable3', class: 'text-center table-size-200-400' }
      ],
      material: {
        var_material1: null,
        var_material2: null,
        var_material3: null,
        var_material4: null,
        var_material5: null,
        var_material6: null,
        var_material7: null,
        var_material8: null,
        var_material9: null,
        imageUrl: null,
        imageUrl2: null
      },
      supplier: {
        var_supplier1: null,
        var_supplier2: null,
        var_supplier3: null,
        var_supplier4: null,
        var_supplier5: null,
        var_supplier6: null
      },
      tmpsupplier: {
        var_supplier1: null,
        var_supplier2: '',
        var_supplier3: '',
        var_supplier4: '',
        var_supplier5: '',
        var_supplier6: ''
      },
      currentPage: 1,
      perPage: 10,
      headerModal: 'กลุ่มวัตถุดิบ',
      modulePath: 'materialGroup'
    }
  }
}
</script>
